import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { ADD, EDIT, IDLE, PENDING } from "const"
import { StateType, hasAccess } from "client/utils"
import {
    PRM_QID_COMPANY,
    StoreType,
    QidCompanyProps,
    LoadQidCompanyById,
    setQidCompanyEdit,
    setQidCompanyReloadEdit,
    initQidCompany,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import AccessDenied from "client/parts/accessDenied"
import Form from "./form"

const Edit = ({
    companyId = null,
}: QidCompanyProps) => {
    const company = useSelector((state: StoreType) => state.qidCompany.companyEdit)
    const reloadEdit = useSelector((state: StoreType) => state.qidCompany.reloadEdit)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setQidCompanyReloadEdit(false))
        setTimeout(() => {
            dispatch(setQidCompanyReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (companyId === 0) {
            dispatch(setQidCompanyEdit(initQidCompany))
            reload()
        } else {
            setLoadState(PENDING)
            LoadQidCompanyById(companyId).then((res) => {
                dispatch(setQidCompanyEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    const addAccess = hasAccess(PRM_QID_COMPANY, ADD)
    const editAccess = hasAccess(PRM_QID_COMPANY, EDIT)

    if (companyId === 0 && !addAccess) return <AccessDenied />
    if (companyId !== 0 && !editAccess) return <AccessDenied />
    if (!company) return <NotFound />

    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {company.id ? `${lang.editCompany} # ${company.id}` : lang.addCompany}
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form company={company} />
                }
                {
                    reloadEdit
                    && <Form company={company} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
